import { render, staticRenderFns } from "./CarReviewTile.vue?vue&type=template&id=a5061ac2&scoped=true"
import script from "./CarReviewTile.vue?vue&type=script&lang=js"
export * from "./CarReviewTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5061ac2",
  null
  
)

export default component.exports